import { heroEntries } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section id="top" className="relative w-full">
      <div className="relative w-full h-[520px] md:h-[640px]">
        <img
          src="https://readdy.ai/api/search-image?query=Moody%20dark%20editorial%20abstract%20background%20with%20crumpled%20torn%20newspaper%20pages%2C%20dramatic%20single%20spotlight%2C%20swirling%20dust%20particles%2C%20deep%20shadows%2C%20cinematic%20atmosphere%2C%20high%20contrast%2C%20artistic%20conceptual%20photography%2C%20muted%20warm%20tones%20with%20crimson%20accent%2C%20no%20text%2C%20no%20faces&width=1600&height=900&seq=hero-expose-2026&orientation=landscape"
          alt="爆料黑料深扒专题合集背景插画"
          title="爆料黑料 深扒专题合集"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/80" />

        <div className="relative z-10 flex flex-col items-center justify-center h-full w-full px-4 text-center">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-background-50/30 bg-background-50/10 text-background-50 text-xs tracking-[0.2em]">
            <i className="ri-bookmark-3-line w-4 h-4 flex items-center justify-center text-accent-300" />
            专题合集 · 连续追更
          </span>
          <h1 className="mt-6 w-full font-heading text-4xl md:text-6xl font-bold text-background-50 tracking-wide">
            爆料黑料 · 深扒专题合集
          </h1>
          <p className="mt-5 max-w-2xl text-sm md:text-base leading-relaxed text-background-100">
            深挖黑料背后真相，从黑料内幕到细节分析，整理完整时间线和证据链。
            想看黑料深扒和证据梳理，这里给你最全的深度挖掘内容。
          </p>
        </div>
      </div>

      {/* 入口条：压顶主导 */}
      <div className="relative z-20 -mt-14 md:-mt-16 px-4 md:px-8">
        <div className="mx-auto max-w-6xl rounded-lg border border-background-200 bg-background-50 p-2 md:p-3">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-1.5 md:gap-2">
            {heroEntries.map((entry) => (
              <a
                key={entry.key}
                href={entry.href}
                className="group flex items-center gap-3 rounded-md px-3 py-3 md:px-4 md:py-4 transition-colors cursor-pointer hover:bg-background-100"
              >
                <span className="flex items-center justify-center w-10 h-10 shrink-0 rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${entry.icon} w-5 h-5 flex items-center justify-center`} />
                </span>
                <span className="flex flex-col min-w-0 text-left">
                  <span className="text-sm font-medium text-foreground-900 truncate">
                    {entry.label}
                  </span>
                  <span className="mt-0.5 text-xs text-foreground-500 truncate">{entry.desc}</span>
                </span>
                <i className="ri-arrow-right-line ml-auto w-4 h-4 hidden md:flex items-center justify-center text-foreground-400 transition-transform group-hover:translate-x-0.5" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}